<template>
  <md-dialog
    :md-active.sync="show"
    @md-clicked-outside="closeDialog"
    @md-closed="closeDialog"
  >
    <md-dialog-title>Revoke Device</md-dialog-title>
    <div
      class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <div v-if="state === 'prompt'" class="md-subheading warning-text">
        After doing this you may need to reactivate {{ device.name }}. Are you
        sure?
        <div dir="rtl">
          <md-button class="md-primary md-raised" @click="revoke"
            >Yes</md-button
          >
          <md-button class="md-primary" @click="closeDialog">Cancel</md-button>
        </div>
      </div>

      <div v-else class="md-subheading warning-text">
        Device revoked successfully.
        <div dir="rtl">
          <md-button class="md-primary md-raised" @click="closeDialog"
            >OK</md-button
          >
        </div>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import fetchErrorHandler from "../error";

export default {
  name: "RevokeDevice",
  props: ["device", "show"],
  data() {
    return {
      state: "prompt"
    };
  },
  methods: {
    closeDialog: function() {
      this.$emit("close");
      this.state = "prompt";
    },
    revoke: async function() {
      let url =
        this.$store.state.server_address + "api/v1/dashboard/revoke-device/";
      let data = {
        device_pk: this.device.device_pk,
        type: this.device.type
      };
      console.warn(data);
      let headers = {
        "Content-Type": "application/json",
        Authorization: this.$store.getters.getAccessToken
      };

      let response = await fetch(url, {
        headers: headers,
        method: "POST",
        body: JSON.stringify(data)
      });

      if (response.status === 401)
        fetchErrorHandler(
          response.status,
          response.statusText,
          this.$options.name
        );
      if (response.status === 200) this.state = "done";
    }
  }
};
</script>

<style scoped></style>
